type LocaleDateFormat = {
  full: string;
  monthDay: string;
};

const fallbackFormat: LocaleDateFormat = {
  full: "YYYY-MM-DD",
  monthDay: "MM-DD",
};

export function getDateFormatsForLocale(locale: string): LocaleDateFormat {
  switch (locale) {
    case "sv-SE":
    case "en-SE":
    case "lt-LT":
    case "zh-CN":
    case "en-CN":
    case "ja-JP":
    case "en-JP":
    case "ko-KR":
    case "en-KR":
    case "en-MY":
    case "ms-MY":
    case "uk-UA":
      return { full: "YYYY-MM-DD", monthDay: "MM-DD" };

    case "en-US":
    case "en-CA":
      return { full: "MM/DD/YYYY", monthDay: "MM/DD" };

    case "de-DE":
    case "de-CH":
    case "fr-CH":
    case "it-CH":
    case "de-AT":
    case "cs-CZ":
    case "fi-FI":
    case "pl-PL":
    case "sk-SK":
    case "sl-SI":
    case "sr-RS":
    case "ru-RU":
    case "hr-HR":
    case "nb-NO":
    case "ro-RO":
      return { full: "DD.MM.YYYY", monthDay: "DD.MM" };

    case "hu-HU":
      return { full: "YYYY.MM.DD", monthDay: "MM.DD" };

    case "en-GB":
    case "en-IE":
    case "en-AU":
    case "en-IN":
    case "fr-FR":
    case "es-ES":
    case "en-ES":
    case "ca-ES":
    case "eu-ES":
    case "gl-ES":
    case "it-IT":
    case "pt-PT":
    case "en-PT":
    case "nl-BE":
    case "fr-BE":
    case "nl-NL":
    case "en-NL":
    case "da-DK":
    case "en-SG":
    case "ar-BH":
    case "en-BH":
    case "ar-JO":
    case "en-JO":
    case "ar-KW":
    case "en-KW":
    case "en-QA":
    case "en-EG":
    case "ar-MA":
    case "en-MA":
    case "fr-MA":
    case "ar-SA":
    case "en-SA":
    case "en-AE":
      return { full: "DD/MM/YYYY", monthDay: "DD/MM" };

    default:
      return fallbackFormat;
  }
}
